import Constants from '@/configs/constants';
import { useEffect, useState } from 'react'

const Separator = ({ char = '=', length = 76 }: { char?: string; length?: number }) => (
  <pre style={styles.separator}>{char.repeat(length)}</pre>
)

export default function ComprovanteContainer() {
  const [comprovante, setComprovante] = useState<Record<string, any> | null>(null)

  useEffect(() => {
    const raw = localStorage.getItem('comprovante')

    if (!raw) {
      console.warn('Nada encontrado no localStorage')
      return
    }

    try {
      const parsed = JSON.parse(raw)
      if (parsed && typeof parsed === 'object' && 'agenciaContaDebitada' in parsed) {
        setComprovante(parsed)
      } else {
        console.warn('Formato inesperado de comprovante:', parsed)
      }
    } catch (err) {
      console.error('Erro ao fazer JSON.parse:', err)
    }
  }, [])

  if (!comprovante) return <div>Carregando comprovante...</div>

  const {
    agenciaContaDebitada,
    contaDebitada,
    agenciaBancaria,
    digitoDaAgenciaBancaria,
    contaBancaria,
    digitoDaContaBancaria,
    totalComEconomia,
    dataTransferencia,
    dataSolicitacao,
    seuNumero,
    bancoOrigem,
    nome,
    cpf,
    tipo
  } = comprovante

  return (
    <div style={styles.container}>
      <Separator />
      {tipo === 'Pix' ? (
        <h2 style={{ ...styles.centeredText, marginBottom: '10px' }}>
          {bancoOrigem} - Comprovante de Transferência PIX
        </h2>
      ) : (
        <>
          <h2 style={{ ...styles.centeredText, marginBottom: '10px' }}>
            {bancoOrigem} - Comprovante de Transferência
          </h2>
          <h4 style={{ ...styles.centeredText, marginBottom: '20px' }}>
            de conta corrente para conta corrente
          </h4>
        </>
      )}
      <Separator />

      <h3 style={styles.block}>Dados da conta debitada:</h3>
      <p style={styles.block}>Nome da empresa: {Constants.NOME_DA_EMPRESA}</p>
      <p style={styles.block}>Agência: {agenciaContaDebitada} Conta corrente: {contaDebitada}</p>
      <Separator />

      <h3 style={styles.block}>Dados da conta creditada:</h3>
      <p style={styles.block}>Nome: {nome}</p>
      <p style={styles.block}>CPF: {cpf}</p>
      {tipo === 'Pix' ? (
        <p style={styles.block}>Finalidade da transação: PIX</p>
      ) :
        (
          <p style={styles.block}>Finalidade da transação: Crédito em conta</p>
        )}
      <p style={styles.block}>Banco:</p>
      <p style={styles.block}>
        Agência: {agenciaBancaria}-{digitoDaAgenciaBancaria} Conta corrente: {contaBancaria}-{digitoDaContaBancaria}
      </p>
      <p style={styles.block}>
        Valor:{' '}
        {totalComEconomia?.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })}
      </p>
      <Separator />

      <p style={styles.block}>Transferência efetuada em: {formatDate(new Date(dataTransferencia))}</p>
      <Separator />

      <p style={styles.block}>Solicitação de depósito: {seuNumero}</p>
      <p style={styles.block}>Data da Solicitação: {formatDate(new Date(dataSolicitacao))}</p>

      <div style={styles.footer}>
        <p>Este comprovante é uma réplica sistêmica do comprovante bancário Febraban.</p>
      </div>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    width: '794px',
    height: '1123px',
    margin: '20px auto',
    fontFamily: '"Courier New", Courier, monospace',
    border: '1px solid #aaa',
    padding: '40px',
    backgroundColor: '#fff',
    boxShadow: '0 0 5px rgba(0,0,0,0.1)',
  },
  centeredText: {
    textAlign: 'center',
    fontWeight: 'normal',
  },
  block: {
    marginLeft: '80px',
  },
  separator: {
    textAlign: 'center',
    margin: '20px 0',
    whiteSpace: 'pre-wrap',
  },
  footer: {
    marginTop: '60px',
    marginLeft: '80px',
    marginRight: '80px',
    textAlign: 'center',
  },
}

function formatDate(date: Date): string {
  const [day, month, year] = [
    String(date.getDate()).padStart(2, '0'),
    String(date.getMonth() + 1).padStart(2, '0'),
    date.getFullYear(),
  ]
  const [hours, minutes, seconds] = [
    String(date.getHours()).padStart(2, '0'),
    String(date.getMinutes()).padStart(2, '0'),
    String(date.getSeconds()).padStart(2, '0'),
  ]
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}